import { useAnalytics } from '../../../utils/analytics/useAnalytics';
import { useEffect } from 'react';
import { QueryType } from '../../../utils/apollo/graphqlSchema';
import { MaybeNil } from '../../../utils/interfaces';
import { isNil } from 'lodash';
import { pageViewed } from '../../../utils/analytics/events/page/events';
import { ANALYTICS_PAGE_NAMES } from '../../../utils/analytics/constants';

export const useFormulaPageViewedEffect = (
  queryType: MaybeNil<QueryType>,
  builderId: MaybeNil<string>,
) => {
  const { track } = useAnalytics();

  useEffect(() => {
    if (!isNil(queryType)) {
      track(
        pageViewed({
          category: 'reports',
          name: `${isNil(builderId) ? 'create' : 'view'} ${ANALYTICS_PAGE_NAMES[queryType]}`,
          id: builderId,
        }),
      );
    }
  }, [builderId, queryType, track]);
};
